import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "A method for estimating the Thiele and Small parameters of an electrodynamic loudspeaker is presented below. Navigate with the arrows to discover it!",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 3,
      colsSize: [1.7, 1],
      rowsSize: [1, 3, 1],
      colSpan: {
        "0:0": 2,
      },
      rowSpan: {
        "1:1": 2,
      },
      gap: "2%",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "impedance Measurement",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/19/principle/slide-2.svg`,
                },
              },
              styles: {
                paddingBottom: "10%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "<ol><li>Connect all elements<li>Play a test signal and record voltages u<sub>1</sub> and u<sub>2</sub> at IN 1 and IN 2<li>Calculate Z<sub>zet</sub> using:</br><math display=inline xmlns=http://www.w3.org/1998/Math/MathML> <msub> <mrow> <mi>Z</mi> </mrow> <mrow> <mi>et</mi> </mrow> </msub> <mo>=</mo> <mfrac> <mrow> <msub> <mrow> <mi>U</mi> </mrow> <mrow> <mi>t</mi> </mrow> </msub></mrow><mrow><mi>I</mi></mrow>  </mfrac> <mo>=</mo> <msub> <mrow> <mi>R</mi> </mrow> <mrow> <mi>p</mi> </mrow> </msub> <mfrac> <mrow> <msub> <mrow> <mi>U</mi> </mrow> <mrow> <mi>t</mi> </mrow> </msub></mrow><mrow><msub> <mrow> <mi>U</mi> </mrow> <mrow> <mi>R</mi> </mrow> </msub></mrow>  </mfrac> <mo>=</mo></math></br> <math display=inline xmlns=http://www.w3.org/1998/Math/MathML> <msub> <mrow> <mi>R</mi> </mrow> <mrow> <mi>p</mi> </mrow> </msub> <mo>(</mo> <mfrac> <mrow> <msub> <mrow> <mi>U</mi> </mrow> <mrow> <mn>1</mn> </mrow> </msub></mrow><mrow><msub> <mrow> <mi>U</mi> </mrow> <mrow> <mn>2</mn> </mrow> </msub></mrow> </mfrac> <mo>-</mo> <mn>1</mn> <mo>)</mo></math></br>where U<sub>1</sub> and U<sub>2</sub> are</br>u<sub>1</sub> and u<sub>2</sub> spectra</ol>",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
              },
            },
          },
        ],
        [],
      ],
    },
  },
};

export default principle;
